import i18n from '@/locale/index'

export default [
  {
    path: '/identity',
    name: 'identity',
    component: () => import('../../views/identityID/index.vue'),
    meta: {
      title: i18n.global.t('identity.title')
    }
  }
]
